<div
	class="container get-table-filter"
	(click)="$event.stopPropagation()"
>
	<div class="search-input-wrapper">
		<app-search-input
			(inputChanged)="onSearchInputChanged($event)"
			[active]="showOverlayContainer"
			(hasFocus)="onHasFocus()"
			[resetInput]="resetInput"
			[placeholder]="placeholder"
			(keydown)="onSearchAreaKeydown($event)"
		></app-search-input>
		<!-- trigger for menu -->
		<button
			class="open-btn"
			cdkOverlayOrigin
			#trigger="cdkOverlayOrigin"
			[attr.aria-label]="'search filter menu' | i18next: { format: 'capitalize' }"
			tabindex="-1"
		></button>
	</div>

	<!-- overlay container that contains tabs and results -->
	<ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayOrigin]="trigger"
		[cdkConnectedOverlayOpen]="showOverlayContainer"
	>
		<div
			class="tabs-results mat-elevation-z4"
			role="region"
			[attr.aria-label]="'search results' | i18next: { format: 'capitalize' }"
			(click)="$event.stopPropagation()"
		>
			<app-simple-tabs
				(clicked)="onTabClicked($event)"
				[tabs]="tabs"
				(firstTabShiftTab)="onFirstTabShiftTab()"
				(lastTabTab)="onLastTabTab()"
			></app-simple-tabs>

			<div class="matches">
				<!-- search status -->
				<div
					*ngIf="searchState === State.Searching"
					class="search-status"
				>
					<mat-spinner diameter="30"></mat-spinner>
				</div>

				<div
					*ngIf="searchState === State.SearchCompleted && viewRecords.length === 0 && !isBusy && pattern"
					class="search-status no-results"
					data-testid="no-matches"
				>
					{{ "no results found" | i18next: { format: "capitalize" } }}
				</div>

				<div
					class="busy"
					*ngIf="isBusy"
				>
					<mat-spinner diameter="30"></mat-spinner>
				</div>

				<!-- matching records -->
				<ng-container *ngIf="searchState === State.SearchCompleted && !isBusy">
					<cdk-virtual-scroll-viewport
						itemSize="36"
						minBufferPx="245"
						maxBufferPx="245"
						class="virtual-scroll"
						#virtualScroll
					>
						<div
							class="record"
							role="option"
							tabindex="0"
							*cdkVirtualFor="let viewRecord of viewRecords; let i = index; templateCacheSize: 0"
							[attr.data-record-index]="i"
							(click)="onClickHighlightedText(viewRecord)"
							(keydown)="onRecordKeydown($event, viewRecord)"
							(focus)="scrollRecordIntoView($event)"
							[ngClass]="{ 'record-disabled': viewRecord.selected }"
							[attr.aria-selected]="viewRecord.selected"
							[attr.aria-posinset]="i + 1"
							[attr.aria-setsize]="viewRecords.length"
						>
							<app-highlighted-text
								[pattern]="pattern"
								[text]="viewRecord.displayValue"
								[selected]="viewRecord.selected"
								*ngIf="viewRecord.record"
							></app-highlighted-text>
						</div>
					</cdk-virtual-scroll-viewport>
				</ng-container>
			</div>
		</div>
	</ng-template>
</div>
